import { IQuestion } from '@/types/IReviewsAndQuestion';
import { mockProducts, mockAccounts } from './reviewsMocks';

// Моковые вопросы (используя те же продукты и аккаунты)
export const mockQuestions: IQuestion[] = [
  {
    id: 1,
    question: 'Как наносить этот хайлайтер?',
    user: mockAccounts[0],
    product: mockProducts[0],
    image: null,
    video: null,
    status: { status: 'pending' },
    answers: [
      {
        id: 1,
        text: 'Нанесите на скулы и спинку носа легкими движениями.',
        user: mockAccounts[1],
        status: { status: 'pending' },
        created_at: '2025-10-01T11:00:00+00:00',
        updated_at: '2025-10-01T11:00:00+00:00'
      }
    ],
    helpful_count: 8,
    not_helpful_count: 1,
    created_at: '2025-09-30T16:00:00+00:00',
    updated_at: '2025-09-30T16:00:00+00:00'
  },
  {
    id: 2,
    question: 'Долго ли держится аромат?',
    user: mockAccounts[1],
    product: mockProducts[1],
    image: null,
    video: null,
    status: { status: 'pending' },
    answers: [
      {
        id: 2,
        text: 'Около 8-10 часов на коже.',
        user: mockAccounts[2],
        status: { status: 'pending' },
        created_at: '2025-09-29T13:00:00+00:00',
        updated_at: '2025-09-29T13:00:00+00:00'
      }
    ],
    helpful_count: 12,
    not_helpful_count: 0,
    created_at: '2025-09-28T14:00:00+00:00',
    updated_at: '2025-09-28T14:00:00+00:00'
  },
  {
    id: 3,
    question: 'Подходит ли для жирной кожи?',
    user: mockAccounts[2],
    product: mockProducts[2],
    image: null,
    video: null,
    status: { status: 'pending' },
    answers: [],
    helpful_count: 3,
    not_helpful_count: 2,
    created_at: '2025-09-26T10:00:00+00:00',
    updated_at: '2025-09-26T10:00:00+00:00'
  },
  {
    id: 4,
    question: 'Есть ли аналоги этого аромата?',
    user: mockAccounts[3],
    product: mockProducts[3],
    image: null,
    video: null,
    status: { status: 'approved' },
    answers: [
      {
        id: 3,
        text: 'Похож на некоторые нишевые бренды, но этот уникален.',
        user: mockAccounts[0],
        status: { status: 'approved' },
        created_at: '2025-09-25T15:00:00+00:00',
        updated_at: '2025-09-25T15:00:00+00:00'
      }
    ],
    helpful_count: 7,
    not_helpful_count: 1,
    created_at: '2025-09-24T12:00:00+00:00',
    updated_at: '2025-09-24T12:00:00+00:00'
  },
  {
    id: 5,
    question: 'Можно ли использовать зимой?',
    user: mockAccounts[0],
    product: mockProducts[4],
    image: null,
    video: null,
    status: { status: 'rejected' },
    answers: [],
    helpful_count: 1,
    not_helpful_count: 4,
    created_at: '2025-09-22T08:00:00+00:00',
    updated_at: '2025-09-22T08:00:00+00:00'
  },
  {
    id: 6,
    question: 'Можно ли использовать продукт на сухой коже?',
    user: mockAccounts[1],
    product: mockProducts[4],
    image: null,
    video: null,
    status: { status: 'approved' },
    answers: [
      {
        id: 4,
        text: 'Да, этот крем отлично подходит для сухой кожи.',
        user: mockAccounts[3],
        status: { status: 'approved' },
        created_at: '2025-09-21T10:00:00+00:00',
        updated_at: '2025-09-21T10:00:00+00:00'
      }
    ],
    helpful_count: 6,
    not_helpful_count: 0,
    created_at: '2025-09-20T11:00:00+00:00',
    updated_at: '2025-09-20T11:00:00+00:00'
  },
  {
    id: 7,
    question: 'Есть ли в составе парабены?',
    user: mockAccounts[2],
    product: mockProducts[0],
    image: null,
    video: null,
    status: { status: 'pending' },
    answers: [],
    helpful_count: 4,
    not_helpful_count: 1,
    created_at: '2025-09-18T09:00:00+00:00',
    updated_at: '2025-09-18T09:00:00+00:00'
  },
  {
    id: 8,
    question: 'Подойдет ли аромат для зимы?',
    user: mockAccounts[0],
    product: mockProducts[1],
    image: null,
    video: null,
    status: { status: 'pending' },
    answers: [
      {
        id: 5,
        text: 'Да, это тёплый и насыщенный аромат для холодного сезона.',
        user: mockAccounts[2],
        status: { status: 'pending' },
        created_at: '2025-09-19T14:00:00+00:00',
        updated_at: '2025-09-19T14:00:00+00:00'
      }
    ],
    helpful_count: 9,
    not_helpful_count: 2,
    created_at: '2025-09-17T16:00:00+00:00',
    updated_at: '2025-09-17T16:00:00+00:00'
  },
  {
    id: 9,
    question: 'Какой объем упаковки?',
    user: mockAccounts[3],
    product: mockProducts[2],
    image: null,
    video: null,
    status: { status: 'approved' },
    answers: [
      {
        id: 6,
        text: 'Объем составляет 30 мл.',
        user: mockAccounts[0],
        status: { status: 'approved' },
        created_at: '2025-09-16T12:00:00+00:00',
        updated_at: '2025-09-16T12:00:00+00:00'
      }
    ],
    helpful_count: 5,
    not_helpful_count: 0,
    created_at: '2025-09-15T13:00:00+00:00',
    updated_at: '2025-09-15T13:00:00+00:00'
  },
  {
    id: 10,
    question: 'Можно ли наносить под макияж?',
    user: mockAccounts[1],
    product: mockProducts[2],
    image: null,
    video: null,
    status: { status: 'pending' },
    answers: [
      {
        id: 7,
        text: 'Да, отлично ложится под макияж.',
        user: mockAccounts[3],
        status: { status: 'approved' },
        created_at: '2025-09-14T11:00:00+00:00',
        updated_at: '2025-09-14T11:00:00+00:00'
      }
    ],
    helpful_count: 7,
    not_helpful_count: 1,
    created_at: '2025-09-13T10:00:00+00:00',
    updated_at: '2025-09-13T10:00:00+00:00'
  },
  {
    id: 11,
    question: 'Есть ли SPF защита?',
    user: mockAccounts[2],
    product: mockProducts[4],
    image: null,
    video: null,
    status: { status: 'rejected' },
    answers: [],
    helpful_count: 2,
    not_helpful_count: 3,
    created_at: '2025-09-12T08:00:00+00:00',
    updated_at: '2025-09-12T08:00:00+00:00'
  },
  {
    id: 12,
    question: 'Подходит ли для чувствительной кожи?',
    user: mockAccounts[0],
    product: mockProducts[0],
    image: null,
    video: null,
    status: { status: 'approved' },
    answers: [
      {
        id: 8,
        text: 'Да, формула гипоаллергенная.',
        user: mockAccounts[1],
        status: { status: 'approved' },
        created_at: '2025-09-11T15:00:00+00:00',
        updated_at: '2025-09-11T15:00:00+00:00'
      },
      {
        id: 9,
        text: 'Рекомендую перед применением сделать тест.',
        user: mockAccounts[2],
        status: { status: 'approved' },
        created_at: '2025-09-11T16:00:00+00:00',
        updated_at: '2025-09-11T16:00:00+00:00'
      }
    ],
    helpful_count: 11,
    not_helpful_count: 0,
    created_at: '2025-09-10T14:00:00+00:00',
    updated_at: '2025-09-10T14:00:00+00:00'
  },
  {
    id: 13,
    question: 'Какой срок годности после вскрытия?',
    user: mockAccounts[3],
    product: mockProducts[3],
    image: null,
    video: null,
    status: { status: 'pending' },
    answers: [],
    helpful_count: 3,
    not_helpful_count: 0,
    created_at: '2025-09-08T12:00:00+00:00',
    updated_at: '2025-09-08T12:00:00+00:00'
  },
  {
    id: 14,
    question: 'Есть ли в наличии другие оттенки?',
    user: mockAccounts[1],
    product: mockProducts[0],
    image: null,
    video: null,
    status: { status: 'approved' },
    answers: [
      {
        id: 10,
        text: 'Да, доступны оттенки от 01 до 05.',
        user: mockAccounts[0],
        status: { status: 'approved' },
        created_at: '2025-09-07T10:00:00+00:00',
        updated_at: '2025-09-07T10:00:00+00:00'
      }
    ],
    helpful_count: 8,
    not_helpful_count: 1,
    created_at: '2025-09-06T09:00:00+00:00',
    updated_at: '2025-09-06T09:00:00+00:00'
  },
  {
    id: 15,
    question: 'Можно ли использовать летом?',
    user: mockAccounts[2],
    product: mockProducts[1],
    image: null,
    video: null,
    status: { status: 'pending' },
    answers: [
      {
        id: 11,
        text: 'Летом он может быть слишком насыщенным.',
        user: mockAccounts[3],
        status: { status: 'pending' },
        created_at: '2025-09-05T13:00:00+00:00',
        updated_at: '2025-09-05T13:00:00+00:00'
      },
      {
        id: 12,
        text: 'Я использую и летом, просто меньше брызгаю.',
        user: mockAccounts[1],
        status: { status: 'pending' },
        created_at: '2025-09-05T14:00:00+00:00',
        updated_at: '2025-09-05T14:00:00+00:00'
      }
    ],
    helpful_count: 6,
    not_helpful_count: 2,
    created_at: '2025-09-04T11:00:00+00:00',
    updated_at: '2025-09-04T11:00:00+00:00'
  },
  {
    id: 16,
    question:
      'Добрый день! У меня очень чувствительная кожа, склонная к аллергическим реакциям. Раньше пробовала несколько тональных кремов от других производителей, и почти все вызывали у меня раздражение, покраснение и зуд. Подскажите, пожалуйста, подойдет ли мне этот тональный крем? Какие компоненты в составе? Есть ли в нем отдушки, парабены, силиконы? Проводились ли дерматологические тесты? Можно ли использовать его ежедневно или лучше только для особых случаев? Также интересует, как он ведет себя на коже в течение дня - не забивает ли поры, не скатывается ли, не подчеркивает ли шелушения? Буду очень благодарна за подробный ответ!',
    user: mockAccounts[0],
    product: mockProducts[2],
    image: null,
    video: null,
    status: { status: 'approved' },
    answers: [
      {
        id: 201,
        text: 'Здравствуйте! У меня тоже чувствительная кожа, и этот крем мне отлично подошел. Использую уже 2 месяца каждый день - никаких проблем не возникало. Текстура легкая, не забивает поры.',
        user: mockAccounts[1],
        status: { status: 'approved' },
        created_at: '2025-10-07T10:00:00+00:00',
        updated_at: '2025-10-07T10:00:00+00:00',
        replies: [
          {
            id: 2001,
            text: 'Спасибо за ваш опыт! Да, этот тональный крем специально разработан для чувствительной кожи. В составе нет парабенов и агрессивных отдушек. Прошел дерматологическое тестирование.',
            user: {
              id: 999,
              phone: 'admin',
              roles: ['ROLE_ADMIN'],
              email: 'admin@example.com',
              name: 'Администратор',
              email_confirmed: true,
              phone_confirmed: true,
              favouriteProducts: [],
              accountDeliveryAddresses: [],
              amount_purchases: 0,
              amount_purchased: 0,
              percent_purchased: 0
            },
            status: { status: 'approved' },
            created_at: '2025-10-07T11:00:00+00:00',
            updated_at: '2025-10-07T11:00:00+00:00'
          }
        ]
      },
      {
        id: 202,
        text: 'Рекомендую перед покупкой обязательно сделать тест на небольшом участке кожи. Даже гипоаллергенные средства могут не подойти из-за индивидуальной непереносимости.',
        user: mockAccounts[2],
        status: { status: 'approved' },
        created_at: '2025-10-07T12:30:00+00:00',
        updated_at: '2025-10-07T12:30:00+00:00',
        replies: [
          {
            id: 2002,
            text: 'Абсолютно верно! Всегда рекомендуем провести тест за 24 часа до полноценного использования. Нанесите небольшое количество на сгиб локтя и проследите за реакцией.',
            user: {
              id: 999,
              phone: 'admin',
              roles: ['ROLE_ADMIN'],
              email: 'admin@example.com',
              name: 'Администратор',
              email_confirmed: true,
              phone_confirmed: true,
              favouriteProducts: [],
              accountDeliveryAddresses: [],
              amount_purchases: 0,
              amount_purchased: 0,
              percent_purchased: 0
            },
            status: { status: 'approved' },
            created_at: '2025-10-07T13:00:00+00:00',
            updated_at: '2025-10-07T13:00:00+00:00'
          }
        ]
      },
      {
        id: 203,
        text: 'Что касается состава - могу сказать, что силиконы там есть, но в минимальном количестве. Они нужны для создания гладкой текстуры. Но они некомедогенные, то есть не забивают поры.',
        user: mockAccounts[3],
        status: { status: 'approved' },
        created_at: '2025-10-07T15:00:00+00:00',
        updated_at: '2025-10-07T15:00:00+00:00',
        replies: [
          {
            id: 2003,
            text: 'Совершенно верно! В формуле используются легкие силиконы последнего поколения, которые не вызывают комедонов. Полный состав можно найти на упаковке или на нашем сайте в карточке товара.',
            user: {
              id: 999,
              phone: 'admin',
              roles: ['ROLE_ADMIN'],
              email: 'admin@example.com',
              name: 'Администратор',
              email_confirmed: true,
              phone_confirmed: true,
              favouriteProducts: [],
              accountDeliveryAddresses: [],
              amount_purchases: 0,
              amount_purchased: 0,
              percent_purchased: 0
            },
            status: { status: 'approved' },
            created_at: '2025-10-07T16:00:00+00:00',
            updated_at: '2025-10-07T16:00:00+00:00'
          }
        ]
      },
      {
        id: 204,
        text: 'По поводу ежедневного использования - я наношу его каждое утро уже 3 месяца, кожа в порядке. Главное - правильно очищать лицо вечером.',
        user: mockAccounts[1],
        status: { status: 'approved' },
        created_at: '2025-10-08T09:00:00+00:00',
        updated_at: '2025-10-08T09:00:00+00:00'
      }
    ],
    helpful_count: 34,
    not_helpful_count: 1,
    created_at: '2025-10-06T18:20:00+00:00',
    updated_at: '2025-10-06T18:20:00+00:00'
  },
  {
    id: 17,
    question:
      'Подскажите, пожалуйста, насколько стойкий этот парфюм? Работаю в офисе с 9 до 18, хотелось бы, чтобы аромат держался весь рабочий день. Также интересует, не будет ли он слишком резким в закрытом помещении? Раньше покупала ароматы, которые коллеги просили не использовать из-за интенсивности. Хочу что-то элегантное, но не навязчивое. Подойдет ли этот вариант?',
    user: mockAccounts[2],
    product: mockProducts[1],
    image: null,
    video: null,
    status: { status: 'pending' },
    answers: [
      {
        id: 205,
        text: 'Аромат действительно стойкий - держится часов 10-12. Но он довольно интенсивный, особенно первые пару часов после нанесения.',
        user: mockAccounts[0],
        status: { status: 'approved' },
        created_at: '2025-10-08T11:00:00+00:00',
        updated_at: '2025-10-08T11:00:00+00:00',
        replies: [
          {
            id: 2004,
            text: 'Для офисного использования рекомендуем наносить 1-2 пшика максимум. Аромат раскроется постепенно и будет звучать элегантно, не перегружая пространство. Также можно наносить на одежду - так шлейф будет более мягким.',
            user: {
              id: 999,
              phone: 'admin',
              roles: ['ROLE_ADMIN'],
              email: 'admin@example.com',
              name: 'Администратор',
              email_confirmed: true,
              phone_confirmed: true,
              favouriteProducts: [],
              accountDeliveryAddresses: [],
              amount_purchases: 0,
              amount_purchased: 0,
              percent_purchased: 0
            },
            status: { status: 'approved' },
            created_at: '2025-10-08T12:00:00+00:00',
            updated_at: '2025-10-08T12:00:00+00:00'
          }
        ]
      },
      {
        id: 206,
        text: 'Я использую его для работы - наношу совсем чуть-чуть утром, и к обеду аромат становится очень деликатным. Никто не жаловался на резкость.',
        user: mockAccounts[3],
        status: { status: 'approved' },
        created_at: '2025-10-08T14:30:00+00:00',
        updated_at: '2025-10-08T14:30:00+00:00'
      },
      {
        id: 207,
        text: 'Важный момент - не наносите его на волосы, если идете в офис. На волосах он держится очень долго и звучит интенсивнее. Лучше на запястья и за уши.',
        user: mockAccounts[1],
        status: { status: 'pending' },
        created_at: '2025-10-08T16:00:00+00:00',
        updated_at: '2025-10-08T16:00:00+00:00'
      }
    ],
    helpful_count: 27,
    not_helpful_count: 2,
    created_at: '2025-10-08T09:45:00+00:00',
    updated_at: '2025-10-08T09:45:00+00:00'
  },
  {
    id: 18,
    question:
      'Здравствуйте! Планирую подарить этот хайлайтер подруге на день рождения, но не уверена, что он ей подойдет. У нее смуглая кожа теплого оттенка. Подскажите, есть ли у этого хайлайтера золотистый подтон или он больше с холодным серебристым сиянием? Также важно - не будет ли он выглядеть на коже слишком искусственно или с эффектом "металлик"? Хочется естественного свечения. Может быть, есть какие-то фото или видео, где можно посмотреть, как он выглядит на разных тонах кожи?',
    user: mockAccounts[3],
    product: mockProducts[0],
    image: null,
    video: null,
    status: { status: 'approved' },
    answers: [
      {
        id: 208,
        text: 'У этого хайлайтера скорее теплый золотистый подтон. На смуглой коже будет смотреться очень красиво и естественно!',
        user: mockAccounts[1],
        status: { status: 'approved' },
        created_at: '2025-10-09T10:00:00+00:00',
        updated_at: '2025-10-09T10:00:00+00:00',
        replies: [
          {
            id: 2005,
            text: 'Да, этот оттенок универсальный и особенно хорошо смотрится на теплых тонах кожи. На нашем сайте в галерее товара есть фото с разными тонами кожи. Также рекомендуем посмотреть наши видеообзоры в разделе "Медиа".',
            user: {
              id: 999,
              phone: 'admin',
              roles: ['ROLE_ADMIN'],
              email: 'admin@example.com',
              name: 'Администратор',
              email_confirmed: true,
              phone_confirmed: true,
              favouriteProducts: [],
              accountDeliveryAddresses: [],
              amount_purchases: 0,
              amount_purchased: 0,
              percent_purchased: 0
            },
            status: { status: 'approved' },
            created_at: '2025-10-09T11:00:00+00:00',
            updated_at: '2025-10-09T11:00:00+00:00'
          }
        ]
      },
      {
        id: 209,
        text: 'У меня как раз смуглая кожа, и этот хайлайтер мой фаворит! Дает естественное сияние без эффекта "новогодней елки". Очень рекомендую!',
        user: mockAccounts[0],
        status: { status: 'approved' },
        created_at: '2025-10-09T13:00:00+00:00',
        updated_at: '2025-10-09T13:00:00+00:00'
      },
      {
        id: 210,
        text: 'Согласна с предыдущими комментариями! Подруге точно понравится. Главное - не переборщить при нанесении, тогда эффект будет максимально естественным.',
        user: mockAccounts[2],
        status: { status: 'approved' },
        created_at: '2025-10-09T15:30:00+00:00',
        updated_at: '2025-10-09T15:30:00+00:00',
        replies: [
          {
            id: 2006,
            text: 'Отличный совет! Для естественного эффекта достаточно легкого прикосновения кистью или пальцем. Можно растушевать спонжем для еще более мягкого свечения.',
            user: {
              id: 999,
              phone: 'admin',
              roles: ['ROLE_ADMIN'],
              email: 'admin@example.com',
              name: 'Администратор',
              email_confirmed: true,
              phone_confirmed: true,
              favouriteProducts: [],
              accountDeliveryAddresses: [],
              amount_purchases: 0,
              amount_purchased: 0,
              percent_purchased: 0
            },
            status: { status: 'approved' },
            created_at: '2025-10-09T16:00:00+00:00',
            updated_at: '2025-10-09T16:00:00+00:00'
          }
        ]
      }
    ],
    helpful_count: 41,
    not_helpful_count: 0,
    created_at: '2025-10-09T08:15:00+00:00',
    updated_at: '2025-10-09T08:15:00+00:00'
  }
];
